var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_269_5312)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14.7283 7.43035C14.3475 7.42998 13.9824 7.27854 13.7131 7.00928C13.4439 6.74002 13.2924 6.37492 13.292 5.99413V4H6.87503C6.62884 3.99991 6.38502 4.04832 6.15754 4.14247C5.93005 4.23663 5.72334 4.37467 5.54922 4.54873C5.3751 4.72279 5.23698 4.92945 5.14274 5.15689C5.0485 5.38434 5 5.62813 5 5.87433V17.1732C5 17.4195 5.0485 17.6632 5.14274 17.8906C5.23698 18.1181 5.3751 18.3248 5.54922 18.4988C5.72334 18.6729 5.93005 18.811 6.15754 18.9051C6.38502 18.9992 6.62884 19.0476 6.87503 19.0476H14.5785C15.0756 19.0476 15.5524 18.8501 15.9038 18.4986C16.2554 18.1471 16.4528 17.6703 16.4528 17.1732V7.43035H14.7283Z",
    fill: "#EF9A9A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.5023 7.48699H14.7778C14.397 7.48662 14.0319 7.33518 13.7626 7.06592C13.4934 6.79666 13.3419 6.43156 13.3416 6.05077V4.05664L16.5023 7.48699Z",
    fill: "#EF9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5223 13.3791H9.47774C9.21417 13.3791 9 13.1167 9 12.7938V10.5848C9 10.2623 9.21417 10 9.47774 10H12.5223C12.7858 10 13 10.2623 13 10.5848V12.7926C13 13.1155 12.7858 13.3791 12.5223 13.3791ZM9.47774 10.3005C9.34907 10.3005 9.24448 10.4283 9.24448 10.5861V12.7938C9.24448 12.9515 9.34907 13.0798 9.47774 13.0798H12.5223C12.6509 13.0798 12.7559 12.9515 12.7559 12.7938V10.5848C12.7559 10.4271 12.6509 10.2993 12.5223 10.2993L9.47774 10.3005Z",
    fill: "#EF9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.878 12.0483H9.12207V12.3476H12.878V12.0483Z",
    fill: "#EF9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.878 11.022H9.12207V11.3212H12.878V11.022Z",
    fill: "#EF9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9163 10.1494H11.6171V13.228H11.9163V10.1494Z",
    fill: "#EF9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.383 10.1494H10.0837V13.228H10.383V10.1494Z",
    fill: "#EF9A9A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 15,
    width: 11,
    height: 5,
    rx: 1,
    fill: "#C62828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86798 18.0488V18.565H9.34351V18.0488H9.86798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7428 18.5286L16.4462 17.4545L15.8088 16.4702H16.2946L16.7074 17.1315L17.1118 16.4702H17.5934L16.9531 17.4699L17.6566 18.5286H17.1553L16.699 17.8167L16.2412 18.5286H15.7428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9017 17.8588L14.3061 17.8195C14.3304 17.9552 14.3796 18.0549 14.4535 18.1186C14.5284 18.1822 14.6291 18.214 14.7554 18.214C14.8893 18.214 14.9899 18.186 15.0573 18.1298C15.1256 18.0727 15.1598 18.0062 15.1598 17.9304C15.1598 17.8817 15.1453 17.8405 15.1163 17.8069C15.0882 17.7722 15.0386 17.7423 14.9674 17.717C14.9188 17.7001 14.8078 17.6702 14.6347 17.6271C14.4119 17.5719 14.2556 17.504 14.1657 17.4235C14.0393 17.3103 13.9762 17.1722 13.9762 17.0093C13.9762 16.9045 14.0056 16.8067 14.0646 16.7159C14.1245 16.6241 14.2102 16.5544 14.3216 16.5067C14.4339 16.4589 14.5691 16.4351 14.7273 16.4351C14.9857 16.4351 15.1799 16.4917 15.31 16.605C15.4411 16.7182 15.5099 16.8694 15.5164 17.0585L15.1008 17.0767C15.083 16.971 15.0447 16.8951 14.9857 16.8493C14.9277 16.8025 14.8401 16.7791 14.7231 16.7791C14.6024 16.7791 14.5078 16.8039 14.4395 16.8535C14.3955 16.8853 14.3735 16.9279 14.3735 16.9812C14.3735 17.0299 14.3941 17.0716 14.4353 17.1062C14.4877 17.1502 14.615 17.1961 14.8172 17.2438C15.0194 17.2916 15.1687 17.3412 15.2651 17.3926C15.3625 17.4432 15.4383 17.5129 15.4926 17.6019C15.5478 17.6898 15.5754 17.7989 15.5754 17.929C15.5754 18.047 15.5426 18.1574 15.4771 18.2604C15.4116 18.3633 15.3189 18.4401 15.1991 18.4906C15.0793 18.5403 14.93 18.5651 14.7512 18.5651C14.491 18.5651 14.2911 18.5052 14.1517 18.3853C14.0122 18.2646 13.9289 18.0891 13.9017 17.8588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2334 18.5284V16.4868H12.649V18.1815H13.6824V18.5284H12.2334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.068 18.5286L10.7714 17.4545L10.134 16.4702H10.6198L11.0326 17.1315L11.437 16.4702H11.9186L11.2783 17.4699L11.9818 18.5286H11.4805L11.0242 17.8167L10.5664 18.5286H10.068Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_269_5312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16.7861,
    fill: "white",
    transform: "translate(5 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.797aad3a36c8cda46d4ed3ce7ec4dae4.svg";
export { ForwardRef as ReactComponent };